import Vue from 'vue';
import CouponCarouselComponent from '../components/shared/coupon-carousel-component.vue';

DM.Module.CouponCarousel = ((DM) => {
    const SELECTOR = '.js-coupon-carousel';
    const ELEMENT = document.querySelector(SELECTOR);
    const ITEMS_IN_VIEWPORT = 3;

    class CouponCarousel {
        constructor(element) {
            this.createComponent(element);
        }

        createComponent(el) {
            const coupons = DM.Boot.MainPage.mainPageCoupons.coupons;
            const itemsInViewport = ITEMS_IN_VIEWPORT;

            return new Vue({
                name: 'dm-coupon-carousel',
                render: h => h(CouponCarouselComponent, { props: { coupons, itemsInViewport }}),
                el,
            });
        }
    }
    if (ELEMENT) {
        new CouponCarousel(ELEMENT);
    }
})(window.DM);
